<template>
	<el-cascader @input="change($event)" v-model="option" :placeholder="placeholder" :disabled="disabled" size="small" filterable clearable :props="props" :options="optionsList" :change-on-select="changeOnSelect" :show-all-levels="showAllLevels"/>
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { model } from 'service/model'
	import mixin, { userMess } from 'M/mixin'
	import province from 'C/province.json'
	import provincecity from 'C/provincecity'
	import { getDepartmentChannel, getConstantByKeyword,deepCopy } from 'service/utils'

	@Component({
		props: ['placeholder', 'groupName', 'result', 'disabled','emitPath', 'changeOnSelect', 'showAllLevels', 'judgeState','isData'],
		data : function(){
			return {
				props : {},
				list : [],
				option : [],
				optionsList : []
			}
		},
		watch: {
			/* option : {
				handler(curVal, oldVal){
					console.log(curVal)
					this.$emit('update:result', curVal)
				},
				deep: true
			}, */
			result : {
				handler(curVal, oldVal){
					this.option = curVal
				},
				deep: true
			},
			list : {
				handler(curVal, oldVal){
					this.optionsList = this.judgeState? this.filterFn(this.list) : this.list
				}
			}
		},
		mixins: [mixin, userMess]
	})

	export default class CascaderTabs extends Vue {

		getProvinceCity(json){
			return deepCopy(json).map(item =>{
				let level2 = item.child
				if(level2){
					item.child = level2.map(le=>{
						return {
							name: le.name
						}
					})
				}
				return item
			})
		}

		mounted(){
			let Arr = []
			let props = {}
			switch(this.groupName){
				case 'channel':
					Arr = this.filterDisabledFn(getDepartmentChannel())
					props = { value: 'id', label: 'channel_name', children: 'child',checkStrictly: this.changeOnSelect,emitPath:this.emitPath ? false : true }
				break;
				case 'channelSearch':
					Arr = getDepartmentChannel()
					props = { value: 'id', label: 'channel_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'filiale':
					Arr = this.convert(getConstantByKeyword('filiale'))
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'allSchool'://分公司分校
					Arr = this.convert(getConstantByKeyword('allSchool'))
					if(this.userMess.branch_id){
						Arr = Arr.filter(item => {
							return item.id == this.userMess.branch_id
						})[0].child
					}
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'bs'://分公司分校
					Arr = this.convert(getConstantByKeyword('allSchool'))
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect,emitPath:this.emitPath ? false : true }
				break;
				case 'department'://部门
					Arr = this.convert(getConstantByKeyword('department'))
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'employeeDepart'://添加员工--部门  展示兄弟部门及其子部门
					let dep_pid = this.userMess.department_pid //登录人父部门
					this.siblingsDept(dep_pid)
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'depart':
					this.departList()
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'bsd':
					Arr = getConstantByKeyword('bsd')
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'departChannelPool':
					this.departList('channelPool')
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				case 'origin':
					Arr = province;
					props = { value: 'name', label: 'name', children: 'child',checkStrictly: this.changeOnSelect}
				break;
				case 'originlevel':
					Arr = this.getProvinceCity(province);
					props = { value: 'name', label: 'name', children: 'child',checkStrictly: this.changeOnSelect}
				break;
				case 'organization':
					Arr = this.convert(getConstantByKeyword('organization'));
					props = { value: 'id', label: 'dep_name', children: 'child',checkStrictly: this.changeOnSelect}
				break;
				case 'role':
					this.getJob()
					props = { value: 'id', label: 'name', children: 'child',checkStrictly: this.changeOnSelect }
				break;
				default: console.log('未定义的'+this.groupName)
			}
			this.props = props
			this.result && this.result.length ? this.option = this.result : ''
			this.list = Arr
		}

		departList(params){
			let dep_id = this.userMess.department_id
			this.fetch(model.getDownDepartment,{
				router: dep_id,
				params: { 
					is_tree: 1
				}
			}).then( res =>{
				if(params){
					this.list = res.filter(item => item.is_resource_entry)
				}else{
					this.list = res
				}
			},data =>{
				return []
			})
		}

		getJob(){
			this.fetch(model.getJob).then( res =>{
				this.list = res    
				if(this.isData){
					this.$emit('dataCallback',res)
				}
			},data =>{
				return []
			})
		}

		siblingsDept(dep_id){ // 获取同级部门
			this.fetch(model.getDownDepartment,{
				router: dep_id,
				params : {
					is_tree : 1
				}
			}).then( res =>{1
				this.list = res && res.length ? res[0].child : res
			},data =>{
				console.error('数据错误')
			})
		}

		filterFn(obj){ // 标记停用的项目，不可选
			let temp = obj.length ? obj : obj.child ? obj.child : []
			return temp.map( item => {
				item.disabled = !item.status
				if(item.child){
					this.filterFn(item)
				}
				return item
			})
		}
		filterDisabledFn(temp){// 过滤停用的项目
			let newArr = deepCopy(temp);
			return newArr.filter( item => {
				if(item.child && item.status == 1){
					item.child = this.filterDisabledFn(item.child)
				}
				return item.status == 1
			})
		}
		change(val) {
			this.$emit('update:result', val)
			this.$emit('callback', val)
		}
	}

</script>




// WEBPACK FOOTER //
// src/components/CascaderTabs.vue